module.exports = __webpack_public_path__ + "static/media/bombolulu_bedsitters9.30cd9433.webp";